import { IContactGroupParticipant } from '@dataTypes/contact.type'
import axios from './axiosConfig'
import { getEnv } from '@utils/env'
import { logger } from '@utils/safeLogger'
import { toApiError } from './errors/api-error'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_CONTACT')

const headers = {
  'Content-Type': 'application/json',
}

interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

type ContactGroupParticipantResponseData = {
  contact_group_participant?: IContactGroupParticipant
}

type BulkContactGroupParticipantResponseData = {
  contact_group_participants?: IContactGroupParticipant[]
}

type ContactGroupParticipantResponse =
  ApiResponse<ContactGroupParticipantResponseData>
type BulkContactGroupParticipantResponse =
  ApiResponse<BulkContactGroupParticipantResponseData>

export const createContactGroupParticipant = async (
  participantDetails: IContactGroupParticipant,
): Promise<ContactGroupParticipantResponse> => {
  try {
    const response = await axios.post<ContactGroupParticipantResponse>(
      `${BUSINESS_LAYER_API}/api/v1/contact/participant`,
      participantDetails,
      {
        headers,
      },
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in createContactGroupParticipant:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const bulkCreateContactGroupParticipant = async (
  participantDetails: IContactGroupParticipant[],
): Promise<BulkContactGroupParticipantResponse> => {
  try {
    const response = await axios.post<BulkContactGroupParticipantResponse>(
      `${BUSINESS_LAYER_API}/api/v1/contact/participant/bulk`,
      participantDetails,
      {
        headers,
      },
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in bulkCreateContactGroupParticipant:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const deleteMultipleContactGroupParticipant = async (
  participantIds: string[],
): Promise<ContactGroupParticipantResponse> => {
  try {
    const response = await axios.delete<ContactGroupParticipantResponse>(
      `${BUSINESS_LAYER_API}/api/v1/contact/participant/bulk`,
      {
        headers,
        data: {
          contact_group_participant_ids: participantIds,
        },
      },
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in bulkDeleteContactGroupParticipant:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}
